// The server answers the full `user-basic` group (email, authenticationMode, hasMfaEnabled, dates…) —
// only the fields the store's View actually reads are declared here. A field never read must not be
// promoted into the store's shape, or every component reaching this store would have it available.
export type FacilityUserPayload = {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly isActive: boolean;
};

export type FacilityUsersFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly FacilityUserPayload[];
};

export type FacilityUsersFetchedAction = {
	type: 'FACILITY_USERS_FETCHED';
	payload: FacilityUsersFetchedPayload;
	facilityId: number;
};

export default (payload: FacilityUsersFetchedPayload, facilityId: number): FacilityUsersFetchedAction => ({
	type: 'FACILITY_USERS_FETCHED',
	payload,
	facilityId,
});
